import { createUserManager } from 'redux-oidc';

import { AUTHORIZE, CLIENT, URL } from '../config/security';
import {URL as HOST} from '../config/nodehost';
const { origin } = window.location;
const logoutURL = `${URL}/logout?redirect_uri=${HOST}&client_id=${CLIENT}`;

/* eslint camelcase: "off" */

export default createUserManager({
  client_id: CLIENT,
  redirect_uri: `${origin}/callback`,
  response_type: 'token',
  scope: '*',
  authority: AUTHORIZE,
  silent_redirect_uri: `${origin}/silent.html`,
  automaticSilentRenew: true,
  loadUserInfo: true,
  metadata: {
    issuer: AUTHORIZE,
    authorization_endpoint: AUTHORIZE,
    token_endpoint: AUTHORIZE,
    userinfo_endpoint: AUTHORIZE,
    revocation_endpoint: logoutURL,
    end_session_endpoint: logoutURL,
    jwks_uri: AUTHORIZE,
    response_types_supported: [
      'token'
    ],
    subject_types_supported: [
      'public'
    ],
    token_endpoint_auth_methods_supported: [
      'client_secret_post'
    ],
    claims_supported: [
      'aud',
      'email',
      'exp',
      'iat',
      'iss',
      'locale',
      'name',
      'sub'
    ],
    code_challenge_methods_supported: [
      'plain',
      'S256'
    ]
  }
});
